import { selectActiveInfrastructureFeatures } from './selectActiveInfrastructureFeatures';
import { IApplicationState } from '../../../common/types/redux';

export function selectActiveInfrastructureFeaturesCount(state: IApplicationState): number {
  const layerFeatures = selectActiveInfrastructureFeatures(state);

  return Object.values(layerFeatures).length;
}
